import { render, staticRenderFns } from "./ReadOnlyField.vue?vue&type=template&id=546ad1aa&scoped=true&"
import script from "./ReadOnlyField.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyField.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyField.vue?vue&type=style&index=0&id=546ad1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ad1aa",
  null
  
)

export default component.exports